import React, { Component } from 'react'
import { connect } from 'react-redux'

import { ENDPOINT_REQUEST } from "@/configurations";
import { stockActions } from '@/actions/trading/stock.action'
import { stockServices } from '@/services/trading-services/stock.services'
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { LOADING_TYPE } from '@/constants/app';
import { Icons, SERVICES_RESP , history} from '@/configurations';
import NoRow from '@/components/DataTable/CustomNoRow';

class MarketIndexMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            titles: props.data,
            load: false,
            noData: false
        }
    }
    render() { 
        const { language} = this.props;
        const { titles, load, noData} = this.state;
        return ( 
            <div className='market-index-container'>
                {load ? <div className='market-index-loading'>
                    <Icons.Loading/> 
                </div> : noData ? <div className='market-index-noData'>{language.common_no_data}</div> 
                    : titles.map((item,index) =>{
                    if(item.data){
                        return(
                            <div className='container-item' key={index}>
                                <div className='item-name'>{this.getLanguageName(item)}</div>
                                <div className={this.getClassStyle(item.data.netChgPrevDay)}>
                                    <div className='item-value'>{item.data.value}</div>
                                    <div className='item-netChgPrev'>
                                        <div className='item-netChgPrevDay'>{item.data.netChgPrevDay}</div>
                                        <div className='item-netChgPrevDatPct'>({this.getPositiveSign(item.data.netChgPrevDatPct)})</div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                })}
            </div>
        );
    }

    getPositiveSign(item) {
        return item > 0 ? `+${item}` : item
    }

    getClassStyle(item) {
        return item > 0 ? 'rise-color' : (item < 0 ? 'fall-color' : 'default-color')
    }

    getLanguageName(item) {
        const { language } = this.props
        if (item.data && item.data.code) {
          switch (language.lang) {
            case 'zh_CN':
              return item.data.scName
            case 'zh_TW':
              return item.data.tcName
            case 'en_US':
              if (isNaN(item.data.code)) {
                return item.data.code
              } else {
                return [item.exchangeID, item.key].join(' ')
              }
            default:
              return item.data.code
          }
        }
        if (isNaN(item.key)) {
          return item.key
        } else {
          return [item.exchangeID, item.key].join(' ')
        }
    }

    componentDidMount(){
        this.getIndexData();
    }

    getIndexData() {
        const { data } = this.props
        this.setState({load: true})
        stockActions.getIndexDataAction({ symbols: data }, res => {
            this.setState({load:false})
            if (res.rtnCode) {
                this.setState({
                    noData: true
                })
                return
            }
            data.forEach((item, index) => {
                if (res.code === item.key) {
                    const titles = JSON.parse(JSON.stringify(this.state.titles))
                    titles[index].data = res
                    this.setState({ 
                        titles,
                        noData: false
                    })
                }
            })
        })
    }
}
 
export default connect(
    state => ({
      language: state.app.language,
      mdsToken: state.trade.mdsToken,
      theme: state.app.theme,
      isMobile: state.app.isMobile,
    }),
    dispatch => ({})
  )(MarketIndexMobile)